import _construct from "/home/fitzwage/Coding/notSoTrivialPursuit/node_modules/@babel/runtime/helpers/esm/construct";
export function fire() {
  var Swal = this;

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return _construct(Swal, args);
}